<template>
  <svg
    aria-hidden="true"
    class="sprite-sheet--conversational">
    <defs>
      <filter id="blur">
        <feGaussianBlur stdDeviation="5" />
      </filter>
      <symbol
        id="envelopeIcon"
        viewBox="0 0 28 28"
        width="32"
        height="32">
        <path d="M28 11.094V23.5c0 1.375-1.125 2.5-2.5 2.5h-23C1.125 26 0 24.875 0 23.5V11.094c.469.516 1 .969 1.578 1.359 2.594 1.766 5.219 3.531 7.766 5.391 1.313.969 2.938 2.156 4.641 2.156h.031c1.703 0 3.328-1.188 4.641-2.156 2.547-1.844 5.172-3.625 7.781-5.391.562-.391 1.094-.844 1.563-1.359zM28 6.5c0 1.75-1.297 3.328-2.672 4.281-2.438 1.687-4.891 3.375-7.313 5.078-1.016.703-2.734 2.141-4 2.141h-.031c-1.266 0-2.984-1.437-4-2.141-2.422-1.703-4.875-3.391-7.297-5.078-1.109-.75-2.688-2.516-2.688-3.938 0-1.531.828-2.844 2.5-2.844h23c1.359 0 2.5 1.125 2.5 2.5z"/>
      </symbol>
      <symbol
        id="closeIcon"
        viewBox="0 0 32 32"
        width="32"
        height="32">
        <path d="M31.708 25.708L22 16l9.708-9.708a1 1 0 0 0 .229-.357c.133-.356.057-.771-.229-1.057L27.122.292c-.286-.286-.702-.361-1.057-.229a.9973.9973 0 0 0-.357.228L16 9.999 6.292.291a.9973.9973 0 0 0-.357-.228C5.579-.07 5.164.006 4.878.292L.292 4.878c-.286.286-.361.702-.229 1.057a1 1 0 0 0 .229.357L10 16 .292 25.708c-.104.105-.18.227-.229.357a.9987.9987 0 0 0 .229 1.057l4.586 4.586c.286.286.702.361 1.057.229a1 1 0 0 0 .357-.229L16 22l9.708 9.708a1 1 0 0 0 .357.229c.356.133.771.057 1.057-.229l4.586-4.586a.9987.9987 0 0 0 .229-1.057 1 1 0 0 0-.229-.357z"/>
      </symbol>
      <symbol
        id="phoneIcon"
        viewBox="0 0 32 32"
        width="32"
        height="32">
        <path d="M23 0H9C7.35 0 6 1.35 6 3v26c0 1.65 1.35 3 3 3h14c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3zM12 1.5h8v1h-8v-1zM16 30c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm8-6H8V4h16v20z"/>
      </symbol>
      <symbol
        id="locationMarkerIcon"
        viewBox="0 0 32 32"
        width="32"
        height="32">
        <path d="M16 0c-5.523 0-10 4.477-10 10 0 10 10 22 10 22s10-12 10-22c0-5.523-4.477-10-10-10zM16 16c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z"/>
      </symbol>
      <symbol
        id="rightArrowIcon"
        viewBox="0 0 32 32"
        width="32"
        height="32">
        <path d="M19.414 27.414l10-10a2 2 0 0 0 0-2.828l-10-10a2 2 0 1 0-2.828 2.828L23.172 14H4a2 2 0 1 0 0 4h19.172l-6.586 6.586c-.39.39-.586.902-.586 1.414s.195 1.024.586 1.414a2 2 0 0 0 2.828 0z"/>
      </symbol>
      <symbol
        id="checkmarkIcon"
        viewBox="0 0 32 32"
        width="32"
        height="32">
        <path d="M27 4L12 19l-7-7-5 5 12 12L32 9z"/>
      </symbol>
      <symbol
        id="twitterIcon"
        viewBox="0 0 32 32"
        width="32"
        height="32">
        <path d="M32 7.075c-1.175.525-2.444.875-3.769 1.031 1.356-.813 2.394-2.1 2.887-3.631-1.269.75-2.675 1.3-4.169 1.594C25.749 4.794 24.043 4 22.155 4c-3.625 0-6.563 2.938-6.563 6.563 0 .512.056 1.012.169 1.494-5.456-.275-10.294-2.888-13.531-6.862-.563.969-.887 2.1-.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-.031-2.087-.331-2.975-.819v.081c0 3.181 2.263 5.838 5.269 6.437-.55.15-1.131.231-1.731.231-.425 0-.831-.044-1.237-.119.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-.531 0-1.05-.031-1.569-.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-.287-.006-.569-.019-.85 1.281-.919 2.394-2.075 3.275-3.394z"/>
      </symbol>
      <symbol
        id="facebookIcon"
        viewBox="0 0 32 32"
        width="32"
        height="32">
        <path d="M19 6h5V0h-5c-3.86 0-7 3.14-7 7v3H8v6h4v16h6V16h5l1-6h-6V7c0-.542.458-1 1-1z"/>
      </symbol>
      <symbol
        id="personIcon"
        width="28"
        height="28"
        viewBox="0 0 28 28">
        <path d="M23.797 20.922c-0.406-2.922-1.594-5.516-4.25-5.875-1.375 1.5-3.359 2.453-5.547 2.453s-4.172-0.953-5.547-2.453c-2.656 0.359-3.844 2.953-4.25 5.875 2.172 3.063 5.75 5.078 9.797 5.078s7.625-2.016 9.797-5.078zM20 10c0-3.313-2.688-6-6-6s-6 2.688-6 6 2.688 6 6 6 6-2.688 6-6zM28 14c0 7.703-6.25 14-14 14-7.734 0-14-6.281-14-14 0-7.734 6.266-14 14-14s14 6.266 14 14z"/>
      </symbol>
      <symbol
        id="personIcon"
        width="28"
        height="28"
        viewBox="0 0 28 28">
        <path d="M23.797 20.922c-0.406-2.922-1.594-5.516-4.25-5.875-1.375 1.5-3.359 2.453-5.547 2.453s-4.172-0.953-5.547-2.453c-2.656 0.359-3.844 2.953-4.25 5.875 2.172 3.063 5.75 5.078 9.797 5.078s7.625-2.016 9.797-5.078zM20 10c0-3.313-2.688-6-6-6s-6 2.688-6 6 2.688 6 6 6 6-2.688 6-6zM28 14c0 7.703-6.25 14-14 14-7.734 0-14-6.281-14-14 0-7.734 6.266-14 14-14s14 6.266 14 14z"/>
      </symbol>
      <symbol
        id="downIcon"
        viewBox="0 0 32 32"
        width="16"
        height="28">
        <path d="M16 11c0 .266-.109.516-.297.703l-7 7C8.516 18.89 8.265 19 8 19s-.516-.109-.703-.297l-7-7C.11 11.516 0 11.265 0 11c0-.547.453-1 1-1h14c.547 0 1 .453 1 1z"/>
      </symbol>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "ConversationalIcons"
};
</script>
